module.exports = __webpack_public_path__ + "static/media/iconSurveys.e758dc64.svg";